import { Colors, Services } from '@sigma-frontend-libs/commons'
import { SendingTypes } from '@sigmasms/shared-types'

import groupButton from '@/components/button/group'
import info from '@/components/info'
import selectorSendername from '@/components/selector/sendername'
import selectorSendingType from '@/components/selector/sendingType'
import { voiceModes } from '@/components/services/sendingsCreate/form'
import attach from '@/components/services/sendingsCreate/form/attach'
import buttons from '@/components/services/sendingsCreate/form/buttons'
import payloadText from '@/components/services/sendingsCreate/form/text'
import tts from '@/components/services/sendingsCreate/form/tts'
import warning from '@/components/services/sendingsCreate/form/warning'
import redirectButton from '@/components/services/sendingsCreate/redirectButton'

function renderTypes(h) {
  return h(
    selectorSendingType,
    {
      props: {
        value: this.proxy.type,
        items: this.types,
        disabled: this.disabled,
        readonly: this.readonly,
        view: 'buttons'
      },
      on: {
        input: event => {
          this.proxy.type = event
        }
      }
    }
  )
}
function renderSenderError(h) {
  return h(
    info,
    {
      props: {
        value: this.getTranslate(`${Services.sendings}.errors.no.sendernames`),
        color: Colors.error
      }
    }
  )
}
function renderSenderField(h) {
  return h(
    selectorSendername,
    {
      props: {
        value: this.proxy.payload.sender,
        type: this.proxy.type,
        combobox: this.service === Services.patterns,
        dense: true
      },
      on: {
        input: event => {
          this.proxy.payload.sender = event
        },
        'sendernames-state': this.handleSendernamesState
      }
    }
  )
}
function renderSenderContent(h) {
  if (this.sendernamesError) {
    return renderSenderError.call(this, h)
  }

  return renderSenderField.call(this, h)
}
function renderSenderRedirectButton(h) {
  return h(
    redirectButton,
    {
      props: {
        service: Services.sendernames
      }
    }
  )
}
function renderSender(h) {
  return h(
    'div',
    {
      class: `${Services.sendings}-create__form-sender`
    },
    [
      renderSenderContent.call(this, h),
      renderSenderRedirectButton.call(this, h)
    ]
  )
}
function renderInfo(h) {
  if (this.showInfo) {
    return h(
      info,
      {
        props: {
          value: this.getTranslate(`${Services.sendings}.infos.variants.${this.proxy.type}`),
          color: Colors.info
        }
      }
    )
  }
}

function renderWarning(h) {
  return h(
    warning,
    {
      props: {
        show: this.checkTestRoute
      }
    }
  )
}
function renderInfoNoText(h) {
  return h(
    info,
    {
      props: {
        value: this.getTranslate(`${Services.sendings}.infos.no.text`),
        color: Colors.grey
      }
    }
  )
}
function renderText(h) {
  return h(
    payloadText,
    {
      props: {
        value: this.proxy.payload.text,
        type: this.proxy.type,
        disabled: this.textDisabled,
        tags: this.customProps.tags,
        customMenu: this.customProps.customMenu
      },
      on: {
        input: event => {
          this.proxy.payload.text = event
        }
      }
    }
  )
}
function renderTextContent(h) {
  if (!('text' in this.proxy.payload)) {
    return renderInfoNoText.call(this, h)
  }

  return renderText.call(this, h)
}
function renderAttach(h) {
  if (this.showAttach) {
    return h(
      attach,
      {
        props: {
          value: this.proxy.payload,
          type: this.proxy.type,
          disabled: this.attachDisabled
        },
        on: {
          input: this.attachHandler
        }
      }
    )
  }
}
function renderTTS(h) {
  return h(
    tts,
    {
      props: {
        value: this.proxy.payload,
        ttsFile: this.ttsFile,
        ttsCooldown: this.ttsCooldown,
        loading: this.ttsLoading,
        disabled: this.ttsDisabled
      },
      on: {
        input: event => {
          this.proxy.payload = event
        },
        generate: this.generateTTS,
        clear: this.attachHandler
      }
    }
  )
}

function renderVoiceContentByTab(h) {
  switch (this.voiceMode) {
    case voiceModes.generate: return renderTTS.call(this, h)
    case voiceModes.upload: return renderAttach.call(this, h)
  }
}
function renderVoiceTabs(h) {
  return h(
    groupButton,
    {
      props: {
        value: this.voiceMode,
        items: this.voiceTabs,
        equalWidth: true,
        fullWidth: true
      },
      on: {
        input: event => {
          this.voiceMode = event
        }
      }
    }
  )
}

function renderFieldsByType(h) {
  switch (this.proxy.type) {
    case SendingTypes.voice: return [
      renderVoiceTabs.call(this, h),
      renderTextContent.call(this, h),
      renderVoiceContentByTab.call(this, h)
    ]
    default: return [
      renderTextContent.call(this, h),
      renderAttach.call(this, h)
    ]
  }
}
function renderButtons(h) {
  return h(
    buttons,
    {
      props: {
        value: this.proxy.payload,
        type: this.proxy.type,
        tags: this.customProps.tags,
        customMenu: this.customProps.customMenu
      },
      on: {
        input: event => {
          this.proxy.payload = event
        }
      }
    }
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: `${Services.sendings}-create__form`
    },
    [
      renderTypes.call(this, h),
      renderSender.call(this, h),
      renderWarning.call(this, h),
      renderInfo.call(this, h),
      renderFieldsByType.call(this, h),
      renderButtons.call(this, h)
    ]
  )
}
